module.exports = __webpack_public_path__ + "assets/4f25fac0ec4d7d81491a7489e438b5fe.svg";